"use client";

import { PropsWithChildren, useEffect } from "react";
import Icon from "../assets/icons";

import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import NavBar from "../components/navbar";
import { Outlet, useNavigate } from "react-router-dom";
import { useMobileDetect } from "hooks/useMobileDetect";

const BottomTabs = () => {
  const router = useNavigate();
  const [activeTab, setActiveTab] = useState("/dashboard");
    const isMobile = useSelector((state: RootState) => state.live.settings.isMobile)
  

  const handleTabClick = (path: string) => {
    router(path);
    setActiveTab(path);
  };

  if (!isMobile) return null;

  return (
    <div className="mt-4">
      <div className="fixed bottom-0 left-0 w-full">
        
        <input
          type="radio"
          id="tab1"
          name="tabs"
          className="absolute opacity-0"
          checked={activeTab === "/dashboard"}
          readOnly
        />
        <input
          type="radio"
          id="tab2"
          name="tabs"
          className="absolute opacity-0"
          checked={activeTab === "/task-list"}
          readOnly
        />

        <nav className="flex items-center justify-between bg-app-blue">
          
          <label
            htmlFor="tab1"
            className="flex-1 flex justify-center items-center p-2 rounded-t-lg cursor-pointer"
            onClick={() => handleTabClick("/dashboard")}
          >
            <img className="w-8 h-8" src={Icon.dashboard} alt="Dashboard" />
          </label>

          <label
            htmlFor="tab2"
            className="flex-1 flex justify-center items-center p-2 rounded-t-lg cursor-pointer"
            onClick={() => handleTabClick("/task-list")}
          >
            <img className="w-8 h-8" src={Icon.pendingTask} alt="Pending Tasks" />
          </label>

        </nav>
      </div>
    </div>
  );
};

const AdminLayout = () => {
  const mobile = useMobileDetect();
  const navigate = useNavigate();
  const { user, isLoading } = useSelector((state: RootState) => state.auth);
  const primaryColor = "#5F488A";

  useEffect(() => {

    // const isMobileDevice = /Android|webOS|iPhone|iPad/i.test(navigator.userAgent);
    if (user) {
      // if (isMobileDevice) {
      //   navigate("/device");
      // }    
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }, [user, navigate]);


  return (
    <div
      className="flex flex-col h-screen"
      style={{ background: primaryColor }}
    >      {user && <NavBar></NavBar>}
      <div className=" bg-[#F9F9F9] rounded-t-3xl flex-1">
        {!isLoading && <main className="flex px-5 flex-col  rounded-t-3xl flex-grow mb-5"><Outlet></Outlet></main>}
      </div>
      <BottomTabs></BottomTabs>
    </div>
  );
};

export default AdminLayout;
